import React from "react";
import { Col, Container, Image, Row, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";

const RecentNews = () => {
    return (
        <Col md="4">
            <Stack className="our-blog-post-right-column">
                <h2>Recent News</h2>
                <Stack className="our-blog-post-list flex-row">
                    <Stack className="blog-post-img">
                        <Image src="/images/blog-post-1.jpg" />
                    </Stack>
                    <Stack className="our-blog-post-list-content">
                        <span>October 20, 2023</span>
                        <label>
                            The Role of AI In Blockchain & Crypto Investments 
                        </label>
                    </Stack>
                </Stack>
                <Stack className="our-blog-post-list flex-row">
                    <Stack className="blog-post-img">
                        <Image src="/images/blog-post-2.jpg" />
                    </Stack>
                    <Stack className="our-blog-post-list-content">
                        <span>October 20, 2023</span>
                        <label>
                            The Role of AI In Blockchain & Crypto Investments 
                        </label>
                    </Stack>
                </Stack>
                <Stack className="our-blog-post-list flex-row">
                    <Stack className="blog-post-img">
                        <Image src="/images/blog-post-3.jpg" />
                    </Stack>
                    <Stack className="our-blog-post-list-content">
                        <span>October 20, 2023</span>
                        <label>
                            The Role of AI In Blockchain & Crypto Investments 
                        </label>
                    </Stack>
                </Stack>
                <Stack className="our-blog-post-list flex-row">
                    <Stack className="blog-post-img">
                        <Image src="/images/blog-post-4.jpg" />
                    </Stack>
                    <Stack className="our-blog-post-list-content">
                        <span>October 20, 2023</span>
                        <label>
                            The Role of AI In Blockchain & Crypto Investments 
                        </label>
                    </Stack>
                </Stack>
            </Stack>
        </Col>
    )
}

export default RecentNews;